import LayerCounterLogic, { LayerType } from "./LayerCounterLogic";
import { set } from "tiny-cookie";

class LayerCounter extends HTMLElement {
    private layerCounterLogic: LayerCounterLogic | undefined;

    connectedCallback(): void {
        const counterString = this.getAttribute("data-counter");
        const counter = counterString ? parseInt(counterString, 10) : NaN;
        const layerType = LayerCounter.toLayerType(this.getAttribute("data-layer-type"));
        this.layerCounterLogic = new LayerCounterLogic(set, window.location);
        this.layerCounterLogic.determineLayerState(counter, layerType);
        this.classList.add("entd-counter--ready");
    }

    private static toLayerType(type: string | null): LayerType {
        switch (type) {
            case "newsletter":
                return "newsletter";
            case "marktforschung":
                return "marktforschung";
            default:
                return "newsletter";
        }
    }
}

customElements.define("entd-layer-counter", LayerCounter);
